import React from 'react';

function Nine() {
    return (
        <div className="blog-post">
            <h1>Cassidy Williams' Visit and Vibe Coding</h1>
            <small>03-22-2026</small>
            <p>
                This past week, <a href='https://www.linkedin.com/in/daliashea/' target="_blank" rel="noopener noreferrer">Dalia Abo Sheasha</a>, a project manager for Visual Studio (not Visual Studio Code) 
                at Microsoft visit our class. Her visit opened my eyes to the reality of how common AI use really is. Throughout this class and my own personal 
                experiences, I've been given the impression that most people in the software development industry take advantage of AI in an organized way. 
                Personally, that's what I do. Before Dalia visited, she had us read a Stack Overflow<a href='https://survey.stackoverflow.co/2025/ai' target="_blank" rel="noopener noreferrer">AI survey</a> 
                that proved that over half of professional developers don't plan on using AI for their projects. Combined with that article, Dalai expressed, during her visit, that many developers 
                that he works with don't use AI extensively. I guess every developer is different.
            </p>
            <br />
            <h2>A Poem on Vibe Coding</h2>
            <p>
                I've been tasked with reading Jake Nations' article <a href='https://www.arthropod.software/p/vibe-coding-our-way-to-disaster' target="_blank" rel="noopener noreferrer">Vibe Coding Our Way to Disaster</a> and Namanyay's article 
                <a href='https://nmn.gl/blog/ai-code-review' target="_blank" rel="noopener noreferrer">AI Makes You Code Faster, But Ship Slower</a>, and writing a poem about my takeaways. I'm choosing to write a haiku:
            </p>
            <p>
                Claude ignores structure
            </p>
            <p>
                Don't sideline AI, instead
            </p>
            <p>
                Code review closely
            </p>
            <br />
            <h2>Nogramming Assignment Progress</h2>
            <p>
                As of now, I haven't began assembling the framework of my LLM. So, I'll continue my task from last week of 
                gluing the LLM pieces together, starting with the weights of the probabilities.
            </p>
        </div>
    );
}

export default Nine;
